module.exports = __webpack_public_path__ + "img/WeChatImage_20210612154320.bd5456f3.jpg";